import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';

import { MiroBoardSelector } from '@techchange/integrations';
import { OAUTH_PROVIDERS, OAUTH_TYPES } from '@techchange/components';

const propTypes = {

	/**
	 * The active Miro API integration (if any) for usage.
	 */
	integration: PropTypes.shape({

		/**
		 * The integration ID.
		 */
		id: PropTypes.string.isRequired,

		/**
		 * The integration type.
		 */
		type: PropTypes.oneOf([OAUTH_TYPES.API]).isRequired,

		/**
		 * The integration provider.
		 */
		provider: PropTypes.oneOf([OAUTH_PROVIDERS.MIRO]).isRequired,

		/**
		 * The name of the integration.
		 */
		name: PropTypes.string.isRequired,

		/**
		 * The logo image (if any) for the integration.
		 */
		logo: PropTypes.string,

		/**
		 * The oauth tokens available to the current user.
		 */
		oauth_integration_tokens: PropTypes.arrayOf(PropTypes.shape({

			/**
			 * The token ID.
			 */
			id: PropTypes.string.isRequired,

		})).isRequired,

	}),

	/**
	 * The function for the click event to close the Miro board selector.
	 */
	onCancel: PropTypes.func.isRequired,

	/**
	 * The function for the click event for the Miro board cards.
	 */
	onSelectBoard: PropTypes.func.isRequired,

	/**
	 * The function used to make API requests through the TechChange
	 * oAuth API for Miro board cards.
	 */
	onUseApiIntegration: PropTypes.func.isRequired,

};

const BoardSelectorModal = (props) => {

	const {
		integration,
		onCancel,
		onSelectBoard,
		onUseApiIntegration,
	} = props;

	const [isOpen, setIsOpen] = useState(true);

	const onToggle = () => {

		// Close the modal
		setIsOpen((prev) => !prev);

		// Close the Miro board selector
		onCancel();

	};

	return (
		<Modal
			className="tc-content-builder-miro-board-selector-modal"
			size="xl"
			isOpen={isOpen}
			toggle={onToggle}>
			<MiroBoardSelector
				integration={integration}
				onCancel={onCancel}
				onUseAPI={onUseApiIntegration}
				onSelectBoard={onSelectBoard} />
		</Modal>
	);

};

BoardSelectorModal.propTypes = propTypes;

export default BoardSelectorModal;
